import axios from "axios";
import Loading from "vue-loading-overlay";
export default {
    name: "Notification",
    components:{Loading},
    data() {
        return {
            isLoading: true,
            fullPage: true,
            loader: "bars",
            authorList: [],
            castList: [],
            packageData: [],
            title: '',
            description: '',
            imageUrl: '',
            author_name: '',
            castcrew_name: '',
            packageid: '',
            audiobook_id: undefined,
            audiobook_title: '',
        }
    },
    async created() {
        await this.getCast();
        await this.getAuthorList();
        await this.getPackageData();
    },
    methods: {
        async getCast() {
            this.isLoading = true;
            const token = localStorage.getItem(this.$tokenKey);
            const res = await axios.get(
                this.$baseUrl + this.$api + this.$version1 + "/audiobooks/castcrew/getall",
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }
            );
            if (res.status === 200) {
                this.castList = res.data.data.map((el) => {
                    return  el.name
                });
                this.isLoading = false;
            }
        },
        async getAuthorList() {
            this.isLoading = true;
            const token = localStorage.getItem(this.$tokenKey);
            const res = await axios.get(
                this.$baseUrl + this.$api + this.$version1 + "/audiobooks/authors/getall",
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }
            );
            if (res.status === 200) {
                this.authorList = res.data.data.map((el) => {
                    return  el.name
                });
                this.isLoading = false;
            }
        },
        async getPackageData() {
            this.isLoading = true;
            const token = localStorage.getItem(this.$tokenKey);
            const res = await axios.get(
                "https://api.kabbik.com/v3/googlepay/googlepay_subscription_list",
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }
            );
            if (res.status === 200) {
                this.isLoading = false;
                this.packageData = res.data.data;
            }
        },
        onImageChange(event) {
            this.imageUrl = event.target.files[0];
        },
        async pushAuthorNotification(e){
            this.isLoading = true;
            const token = localStorage.getItem(this.$tokenKey);
            try {
                const formData = new FormData();
                formData.append("title", this.title);
                formData.append("description", this.description);
                formData.append("files", this.imageUrl);
                formData.append("author_name", this.author_name);
                const res = await axios.post(
                    this.$baseUrl + this.$api + this.$version3 + "/pushnotification/gotoAuthorActivity",
                    formData,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            "Content-Type": "application/json",
                        },
                    }
                );
                this.isLoading = false;
                if (res.status === 201 || res.status === 200) {
                    // if(res.data.data.success === 1) {
                        this.isLoading = false;
                        // let li = ''
                        // for (let index = 0; index < res.data.data.results.length; index++){
                        //     li += '<li class="list-group-item px-0"> '+ res.data.data.results[index].message_id +' </li>';
                        // }
                        // let html = '<ul class="list-group list-group-flush">\n' +
                        //     li +
                        //     '</ul>'
                        this.$swal.fire({
                            icon: "success",
                            title: "Notification send successfully",
                            // html: html
                        })
                        e.target.reset()
                        await this.clearData()
                    // } else {
                    //     this.isLoading = false;
                    //     this.$swal.fire({
                    //         icon: "error",
                    //         title: "Notification send Failed",
                    //     })
                    // }

                } else {
                    this.isLoading = false;
                    this.$vToastify.error("Notification send Failed");
                }
            } catch (error) {
                console.log(error);
                this.isLoading = false;
                this.$swal.fire({
                    icon: "error",
                    text: "An error occurred!"
                });
            }
        },
        async pushCastCrewNotification(e){
            this.isLoading = true;
            const token = localStorage.getItem(this.$tokenKey);
            try {
                const formData = new FormData();
                formData.append("title", this.title);
                formData.append("description", this.description);
                formData.append("files", this.imageUrl);
                formData.append("castcrew_name", this.castcrew_name);
                const res = await axios.post(
                    this.$baseUrl + this.$api + this.$version3 + "/pushnotification/gotoCastcrewActivity",
                    formData,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            "Content-Type": "application/json",
                        },
                    }
                );
                this.isLoading = false;
                if (res.status === 201 || res.status === 200) {
                    // if(res.data.data.success === 1) {
                        this.isLoading = false;
                        // let li = ''
                        // for (let index = 0; index < res.data.data.results.length; index++){
                        //     li += '<li class="list-group-item px-0"> '+ res.data.data.results[index].message_id +' </li>';
                        // }
                        // let html = '<ul class="list-group list-group-flush">\n' +
                        //     li +
                        //     '</ul>'
                        this.$swal.fire({
                            icon: "success",
                            title: "Notification send successfully",
                            // html: html
                        })
                        e.target.reset()
                        await this.clearData()
                    // } else {
                    //     this.isLoading = false;
                    //     this.$swal.fire({
                    //         icon: "error",
                    //         title: "Notification send Failed",
                    //     })
                    // }

                } else {
                    this.isLoading = false;
                    this.$vToastify.error("An error occurred");
                }
            } catch (error) {
                console.log(error);
                this.isLoading = false;
                this.$swal.fire({
                    icon: "error",
                    text: "An error occurred!"
                });
            }
        },
        async pushAudiobookDetailsNotification(e){
            this.isLoading = true;
            const token = localStorage.getItem(this.$tokenKey);
            try {
                const formData = new FormData();
                formData.append("title", this.title);
                formData.append("description", this.description);
                formData.append("audiobook_id", this.audiobook_id);
                formData.append("audiobook_title", this.audiobook_title);
                formData.append("files", this.imageUrl);
                const res = await axios.post(
                    this.$baseUrl + this.$api + this.$version3 + "/pushnotification/gotoDetailsActivity",
                    formData,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            "Content-Type": "application/json",
                        },
                    }
                );
                this.isLoading = false;
                if (res.status === 201 || res.status === 200) {
                    // if(res.data.data.success === 1) {
                    //     this.isLoading = false;
                    //     let li = ''
                    //     for (let index = 0; index < res.data.data.results.length; index++){
                    //         li += '<li class="list-group-item px-0"> '+ res.data.data.results[index].message_id +' </li>';
                    //     }
                    //     let html = '<ul class="list-group list-group-flush">\n' +
                    //         li +
                    //         '</ul>'
                        this.$swal.fire({
                            icon: "success",
                            title: "Notification send successfully",
                        })
                        e.target.reset()
                        await this.clearData()

                } else {
                    this.isLoading = false;
                    this.$vToastify.error("Notification send Failed");
                }
            } catch (error) {
                console.log(error);
                this.isLoading = false;
                this.$swal.fire({
                    icon: "error",
                    text: "An error occurred!"
                });
            }
        },
        async pushQuizNotification(e){
            this.isLoading = true;
            const token = localStorage.getItem(this.$tokenKey);
            try {
                const formData = new FormData();
                formData.append("title", this.title);
                formData.append("description", this.description);
                formData.append("files", this.imageUrl);
                const res = await axios.post(
                    this.$baseUrl + this.$api + this.$version3 + "/pushnotification/gotoQuizActivity",
                    formData,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            "Content-Type": "application/json",
                        },
                    }
                );
                this.isLoading = false;
                if (res.status === 201 || res.status === 200) {
                    // if(res.data.data.success === 1) {
                        this.isLoading = false;
                        // let li = ''
                        // for (let index = 0; index < res.data.data.results.length; index++){
                        //     li += '<li class="list-group-item px-0"> '+ res.data.data.results[index].message_id +' </li>';
                        // }
                        // let html = '<ul class="list-group list-group-flush">\n' +
                        //     li +
                        //     '</ul>'
                        this.$swal.fire({
                            icon: "success",
                            title: "Notification send successfully",
                        })
                        e.target.reset()
                        await this.clearData()
                    // } else {
                    //     this.isLoading = false;
                    //     this.$swal.fire({
                    //         icon: "error",
                    //         title: "Notification send Failed",
                    //     })
                    // }

                } else {
                    this.isLoading = false;
                    this.$vToastify.error("Notification send Failed");
                }
            } catch (error) {
                console.log(error);
                this.isLoading = false;
                this.$swal.fire({
                    icon: "error",
                    text: "An error occurred!"
                });
            }
        },
        async pushSubscriptionNotification(e){
            this.isLoading = true;
            const token = localStorage.getItem(this.$tokenKey);
            try {
                const formData = new FormData();
                formData.append("title", this.title);
                formData.append("description", this.description);
                formData.append("packageid", this.packageid);
                formData.append("files", this.imageUrl);
                const res = await axios.post(
                    this.$baseUrl + this.$api + this.$version3 + "/pushnotification/gotoSubscriptionPage",
                    formData,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            "Content-Type": "application/json",
                        },
                    }
                );
                this.isLoading = false;
                if (res.status === 201 || res.status === 200) {
                    // if(res.data.data.success === 1) {
                        this.isLoading = false;
                        // let li = ''
                        // for (let index = 0; index < res.data.data.results.length; index++){
                        //     li += '<li class="list-group-item px-0"> '+ res.data.data.results[index].message_id +' </li>';
                        // }
                        // let html = '<ul class="list-group list-group-flush">\n' +
                        //     li +
                        //     '</ul>'
                        this.$swal.fire({
                            icon: "success",
                            title: "Notification send successfully",
                        })
                        e.target.reset()
                        await this.clearData()
                    // } else {
                    //     this.isLoading = false;
                    //     this.$swal.fire({
                    //         icon: "error",
                    //         title: "Notification send Failed",
                    //     })
                    // }

                } else {
                    this.isLoading = false;
                    this.$vToastify.error("Notification send Failed");
                }
            } catch (error) {
                console.log(error);
                this.isLoading = false;
                this.$swal.fire({
                    icon: "error",
                    text: "An error occurred!"
                });
            }
        },
        async clearData() {
                this.title = '';
                this.description = '';
                this.imageUrl = '';
                this.author_name = '';
                this.castcrew_name = '';
                this.audiobook_id = undefined;
                this.packageid = '';
                this.audiobook_title = ''
        }
    }
}
